export default "__VITE_ASSET__D9Tt9DUz__";